import {useState,useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import SettingsMenu from '../../staticscreens/SettingsMenu';
import moment from 'moment';
import { DeleteVoiceCallListService, GetVoiceCallListService } from '../../../services/admin/VoiceCallListServices';
import { IconButton } from '@mui/material'
import {BsArrowRepeat} from 'react-icons/bs';
import {FiChevronRight,FiChevronLeft} from 'react-icons/fi';
import { AiOutlineDelete } from 'react-icons/ai';


function VoiceCallList() {


    const [data,setdata] = useState([])
    const [page,setpage] = useState(1)

    const navigator = useNavigate()


  
    useEffect(()=>{
        getVoiceCall()
    },[page])

    
    

  
  async function getVoiceCall(){
   const response = await GetVoiceCallListService(page)
   setdata(response.data)
  }  

  async function resetfunc(){
    setpage(1)
    const response = await GetVoiceCallListService(1)
    setdata(response.data)
  }  

   async function deleteData(d) {
      await DeleteVoiceCallListService(d?._id)
      const response = await GetVoiceCallListService(page)
      setdata(response.data)
    }
    
  

  
  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen box-border md:overflow-hidden'>
   
  
      <div className='block sm:flex'>
        <SettingsMenu />

        <div className='md:w-[88%] px-4'>
        <div >
        <div className='pt-5'>
        <div className="flex justify-between align-center items-center border-b pb-2 ">
        <span className="font-[800] text-[14px]">Voice Call List ({data?.pagination?.total})</span>


         <div className='flex items-center'>
            <div className='flex items-center  text-[12px] mr-2'>

            <h6 className='mr-2 font-[500]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit } - {data?.pagination?.limit} of {data?.pagination?.total} </h6>
            <IconButton onClick={resetfunc}><BsArrowRepeat size={16} /></IconButton>

            <div>
            <IconButton onClick={()=>{page > 1 ? setpage(page-1) : console.log('')}} ><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
            <IconButton onClick={()=>{ page < data?.pagination?.totalPages  ? setpage(page+1) : console.log('')}}><FiChevronRight className={`${data?.pagination?.totalPages === page ? 'opacity-50' : 'opacity-100'}`}  size={16} /></IconButton>

            </div>
            </div>
        </div>    
        
        </div>
        </div>

        {data?.datas?.length === 0 &&
        <div className='grid place-items-center mt-20  items-center justify-center'>
        <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' /> 
        <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
        <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data added based on your current page option please click on add the data button to see list here.</h6>
      </div>
       }


        {data?.datas?.length > 0 &&
        <div className='grid grid-cols-2 md:max-h-[89vh] md:overflow-y-scroll md:grid-cols-5 gap-1 mt-2'>
            {data?.datas?.map((d,i)=>(
            <div key={d?.id}  className='border cursor-pointer items-center relative justify-between px-2 py-1 border-b'>
               {/* <div onClick={()=>deleteData(d)} className='bg-white absolute top-1 right-1 p-1 z-10 border'>
                  <AiOutlineDelete />
                </div> */}
                <h6 onClick={()=>navigator('detail',{state:d})}  className='text-[13px] font-[400] '>Campaign Type : <b>{d.campaign_type}</b></h6>
                <h6 onClick={()=>navigator('detail',{state:d})}  className='text-[11px]'>Campaign Name : <span className='font-[800]'>{d?.campaign_name}</span></h6>
                <h6 onClick={()=>navigator('detail',{state:d})}  className='text-[11px] font-[400] mt-1'>Targeted Time : <span className='font-[800]'>{moment(d?.scheduled_at)?.format('LLL')}</span></h6>
                  <div onClick={()=>navigator('detail',{state:d})}  className='border mt-1 text-[11px]'> 
                    <div className='flex items-center border-b '>
                      <h6 className='w-[70%] border-r bg-[#de9f19]/60  p-1 '>Customer Targeted</h6>
                      <h6 className='w-[30%] font-[800] p-1'>{d?.targeted_customer?.length}</h6>
                    </div>  
                    <div className='flex items-center'>
                      <h6 className='w-[70%] border-r bg-[#de9f19]/60 p-1 '>Customer Answered</h6>
                      <h6 className='w-[30%] font-[800] p-1'>{d?.targeted_customer?.filter(f=>f?.status === 'ANSWERED')?.length + d?.targeted_customer?.filter(f=>f?.status === 'ANSWERED AND PRESSED 1')?.length}</h6>
                    </div>  
                 </div>    
                <h6 className='text-[10px] font-[400] bg-slate-100 mt-2 p-1'>Created At : <span className='text-[10px] font-[600] leading-normal'>{moment(d.createdAt).format('LLL')}</span> </h6>
             
            </div>
            ))}
        </div>}
          </div>
        </div>
      </div> 
    </div>
  )
}

export default VoiceCallList